import { Box, Button, Flex, theme, Typography } from '@fe-toolkit/web-components/ssr'

import Image from '@/components/atoms/Image'

export function NoPlanOrOrderSection() {
  return (
    <Box
      as="section"
      sx={({ theme }) => ({
        [theme.breakpoints.up('medium')]: {
          display: 'flex',
          columnGap: theme.spacing.medium,
          alignItems: 'center',
          justifyContent: 'center',
        },
      })}
    >
      <Box
        sx={({ theme }) => ({
          maxWidth: '352px',
          margin: '0 auto',
          [theme.breakpoints.up('medium')]: {
            flexBasis: '45%',
          },

          // included because the Image tag itself only allows numbers, not percentages, so the images isn't responsive
          '> img': {
            width: '100%',
            height: '100%',
          },
        })}
      >
        <Image alt="a picture of an eero router" height="600" src={'/eero-2.png'} width="600" />
      </Box>

      <Flex sx={{ flexBasis: '55%', rowGap: theme.spacing.small, flexDirection: 'column' }}>
        <Typography as="h2" sx={{ maxWidth: theme.layout.readableWidth }} variant="shout">
          Broadband with no sneaky price hikes
        </Typography>
        <Typography as="p" variant="speak">
          Fast full fibre, the giffgaff way. Broadband you can rely on.
        </Typography>
        <Box>
          <Button
            href="/broadband"
            isFullWidth={{ down: 'medium' }}
            sx={{ marginTop: theme.spacing.small }}
            variant="primary"
          >
            Find my deal
          </Button>
        </Box>
      </Flex>
    </Box>
  )
}
